var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditIcon22X22 = function SvgEditIcon22X22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "left-arrow-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-edit-2",
    d: "M13.989 1.927a2.45 2.45 0 1 1 3.464 3.464L5.763 17.08 1 18.379l1.3-4.763Z",
    fill: "none"
  })));
};
export default SvgEditIcon22X22;